export default __webpack_public_path__ + "static/media/sk.ad3e7b84.jpg";